import { Controller } from '@hotwired/stimulus';
import { Toast } from '../toast';

export default class extends Controller {
  static values = { successMessage: String, errorMessage: String };
  static targets = ['form'];

  connect() {
    if (this.hasSuccessMessageValue) {
      this.showToast(this.successMessageValue, true);
    } else if (this.hasErrorMessageValue) {
      this.showToast(this.errorMessageValue, false);
    }
  }

  showToast(message, success = true) {
    if (success) {
      Toast.success(Toast.successTitle(), message);
    } else {
      Toast.error(Toast.errorTitle(), message);
    }
  }

  submitForm() {
    this.formTarget.requestSubmit();
  }
}
